import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

import Status from 'scenes/CustomAudiences/LookalikeAudiences/components/Status';

const Metadata = ({ data }) => {
  return (
    <DescriptionList
      variant={'column'}
      data={data}
      stripEmpty={true}
      disableGutters={true}
    >
      <DescriptionItem
        label={'Status'}
        field={'filterStatus'}
        type={({ value, ...other }) => (
          <Status id={value.id} {...other}>
            {value.name}
          </Status>
        )}
      />
      <DescriptionItem
        label={'Size'}
        field={'approximateUsers'}
        textVariant={'h6'}
        type={'decimal'}
      />
      <DescriptionItem
        label={'Last sync'}
        field={'lastSyncDate'}
        type={'date'}
        template={'LLL'}
        timeZone={'utc'}
      />
      <DescriptionItem
        label={'Created by'}
        type={'metadata'}
        value={data}
        userField={'createdBy.name'}
        dateField={'createdDate'}
      />
    </DescriptionList>
  );
};

export default Metadata;
